<template>
  <div v-if="!isIdealEUplan">
    <public-announcement :is-fixed="true" />
    <div class="referral">
      <page-breadcrumb
        :category="$i18nPresenter.t('account')"
        :text="breadcrumbText"
      />

      <div class="referral-content">
        <aha-section class="relative">
          <template #header>
            <h5>{{ $i18nPresenter.t('Refer to earn') }}</h5>
          </template>
          <template #body>
            <ReferralTeacherBody v-if="currentUser.id" class="mt-2 mb-8" />
            <img src="@/assets/images/icon/invite-friend.png" class="invite-friend" width="390">
          </template>
        </aha-section>
        <ReferrerHistory />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// UI
import PageBreadcrumb from '../common/page-breadcrumb/PageBreadcrumb.vue'
import ReferrerHistory from '@/components-v2/referral/ReferrerHistory.vue'
import ReferralTeacherBody from './ReferralTeacherBody.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'

export default {
  components: {
    PageBreadcrumb,
    ReferrerHistory,
    ReferralTeacherBody,
    PublicAnnouncement,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    breadcrumbText() {
      return this.$i18nPresenter.t('Refer a Teacher')
    },
    isIdealEUplan() {
      return this.currentUser.currency === 'eur'
    },
  },
  mounted() {
    if (this.isIdealEUplan) this.$router.push({ name: 'Error404' })
  },
}
</script>

<style lang="scss" scoped>
.referral {
  @apply p-4 md:px-10 md:py-6;
}
.referral-content {
  @apply flex flex-col justify-center md:w-10/12 md:mx-auto;
}
.invite-friend {
  position: absolute;
  bottom: 0;
  right: 0;

  @media (max-width: 1024px) {
    position: inherit;
    margin: 0 auto;
  }
}
</style>
